import type { ButtonHTMLAttributes, PointerEvent } from "react";

type Props = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "default" | "primary" | "rail";
  arrow?: boolean;
};

export function JellyButton({ variant = "default", arrow, className = "", onPointerDown, ...props }: Props) {
  const press = (event: PointerEvent<HTMLButtonElement>) => {
    const rect = event.currentTarget.getBoundingClientRect();
    event.currentTarget.style.setProperty("--press-x", `${event.clientX - rect.left}px`);
    event.currentTarget.style.setProperty("--press-y", `${event.clientY - rect.top}px`);
  };
  return (
    <button
      {...props}
      onPointerDown={(event) => {
        press(event);
        onPointerDown?.(event);
      }}
      className={`jelly-button jelly-button--${variant} ${arrow ? "has-arrow" : ""} ${className}`}
    />
  );
}
